import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    [
      _vm.$route.meta.public
        ? [
            _c(
              "transition",
              [
                _c(
                  "keep-alive",
                  [_c("router-view", { key: _vm.$route.fullpath })],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _vm.finished ? _c("app-toolbar") : _vm._e(),
            _c(
              VMain,
              { staticClass: "background" },
              [
                _c("app-breadcrumbs", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.finished,
                      expression: "finished",
                    },
                  ],
                  attrs: { items: _vm.breadcrumbItems },
                }),
                _c(
                  VContainer,
                  { staticClass: "page-wrapper", attrs: { fluid: "" } },
                  [_vm.finished ? _c("router-view") : _vm._e()],
                  1
                ),
              ],
              1
            ),
            _c(
              VFooter,
              {
                staticClass: "footer lighten-1 app--footer pa-3",
                attrs: { height: "auto", app: "" },
              },
              [
                _c(
                  VRow,
                  {
                    staticClass: "justify-center mt-0",
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c("span", { staticClass: "caption" }, [
                      _vm._v(" Desenvolvido por "),
                      _c("b", [_vm._v("Universidade Federal do Ceará (UFC)")]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
      _c("app-loading", {
        attrs: { visibilidade: !_vm.finished || _vm.loading },
      }),
      _c("app-snackbar", {
        attrs: {
          descricao: _vm.snackbar.texto,
          cor: _vm.snackbar.cor,
          visibilidade: _vm.snackbar.visibilidade,
        },
      }),
      _c("dialog-info", { attrs: { value: _vm.aviso } }),
      _c("app-tutorial", {
        attrs: {
          tutorial: _vm.tutorial.nome,
          "dialog-visible": _vm.tutorial.visibilidade,
          "toggle-visible": _vm.toogleTutorial,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }